// extracted by mini-css-extract-plugin
export default {"background":"styles_background__1yhm-","logo":"styles_logo__bK117"};